import { FormGroup } from "@angular/forms";

export namespace FormUtility {

    export function getEnabledFormValues<T>(
        form: FormGroup
    ): Partial<T> {
        return Object.entries(form.controls)
            .filter(([_, control]) => control.enabled)
            .reduce((acc, [key, control]) => ({
                ...acc,
                [key]: control.value
            }), {});
    }

}

